export const caaSubdomainValidator = (value) => {
    if (!value) return true;

    const regex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return regex.test(value) || value === "@" ? true : "validate.caa_subdomain_format";
}; 